import SubscriptionPageContent from "components/subscription/subscriptionPageContent";

const Subscription = () => {
  return <SubscriptionPageContent />;
};

export default Subscription;
